<template>
  <div
    class="absolute bottom-0 z-10 flex flex-col w-full bg-white h-28 opacity-90"
    :class="[{ 'bottom-4': hasScrollBar }]"
  >
    <div class="flex self-center py-3 text-xs font-light text-center text-gray-800 w-fit">
      {{
        t('displayed_count', {
          total: numVariants,
          count: numShowing,
        })
      }}
    </div>
    <div class="flex self-center w-fit">
      <CButton variant="secondary" @click="expand()">
        {{ t('show_all_variants') }}
      </CButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

type Props = {
  previewLimit?: number | null;
  numVariants?: number | null;
  hasScrollBar?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  previewLimit: null,
  numVariants: null,
});

const emit = defineEmits<{
  (e: 'expand'): void;
}>();

const { t } = useI18n();

const variantsCovered = ref(2);

const numShowing = computed(() => props.previewLimit - variantsCovered.value);

const expand = () => emit('expand');
</script>

<script lang="ts">
export default defineComponent({
  name: 'VariantsOverlay',
});
</script>
